/**
 * Generic toast notifications using react-hot-toast.
 * Export Toaster (mount once in app) and toast helpers for use anywhere.
 */
import { Toaster as HotToaster } from 'react-hot-toast';

const toastOptions = {
    duration: 4000,
    position: 'top-center',
    style: {
        borderRadius: '10px',
        padding: '10px 20px',
        fontFamily: "var(--font-body)",
        fontSize: '14px',
        fontWeight: 500,
        backgroundColor: '#1a1a1a',
        color: '#fff',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    },
    success: {
        iconTheme: { primary: '#25D366', secondary: '#fff' },
    },
    error: {
        iconTheme: { primary: '#ef4444', secondary: '#fff' },
    },
    loading: {
        iconTheme: { primary: '#3b82f6', secondary: '#fff' },
    },
};

/**
 * Mount once at app root (e.g. in demo.jsx).
 */
export function Toaster() {
    return (
        <HotToaster
            toastOptions={toastOptions}
            containerStyle={{ top: 24 }}
        />
    );
}

/**
 * Re-export toast from react-hot-toast so the app uses a single import.
 * Use: toast.success('Saved'), toast.error('Failed'), toast.loading('...'), etc.
 */
export { default as toast } from 'react-hot-toast';
